import { Alert } from 'react-bootstrap-5';
import PropTypes from 'prop-types';
import React from 'react';
import { useBuildoutOsDisplay } from 'components/buildout_os_display';

export default function LeadAlert({ errorMessage, showAlert }) {
  const buildoutOs = useBuildoutOsDisplay();
  if (!showAlert) return null;

  const message = errorMessage || `${buildoutOs ? 'Inquiry' : 'Lead'} has already been added to this project`;

  return (
    <Alert name="errors-alert" variant="danger">{message}</Alert>
  );
}

LeadAlert.propTypes = {
  errorMessage: PropTypes.string,
  showAlert: PropTypes.bool
};
